import Image from "next/image";
import React, { type FC } from "react";
import { type ArticlePreviewType } from "~/types";
import AliceCarousel, { Link } from "react-alice-carousel";
import { RESPONSIVE_CAROUSEL } from "~/utils/constants";
import PrevButton from "../PrevButton";
import NextButton from "../NextButton";
type CarouselThumbLoopProps = {
  articleThumbLoop: ArticlePreviewType[];
};

const CarouselThumbLoop: FC<CarouselThumbLoopProps> = ({
  articleThumbLoop,
}) => {
  return (
    <AliceCarousel
      mouseTracking={true}
      infinite={true}
      responsive={{
        0: { items: 1 },
        640: { items: 2 },
        1024: { items: 3 },
        1300: { items: 4 },
      }}
      autoPlay={true}
      autoPlayStrategy="all"
      autoPlayInterval={4000}
      disableDotsControls={true}
      disableButtonsControls={false}
      renderPrevButton={() => {
        return articleThumbLoop.length > 2 && <PrevButton color="#fff" />;
      }}
      renderNextButton={() => {
        return articleThumbLoop.length > 2 && <NextButton color="#fff" />;
      }}
    >
      {articleThumbLoop.map((article, index) => (
        <article
          key={`${article.post_name}`}
          className="articleWrap carousel-cell flex w-full flex-col px-2"
        >
          <figure>
            <Link
              href={`/a/${article.post_name}`}
              className={`flex w-full rounded-[50px] bg-lightLightGray transition-all ${
                articleThumbLoop.length < 2 ? "md:max-w-[426px]" : ""
              }`}
            >
              {article.thumbnail != null && (
                <Image
                  src={article.thumbnail}
                  alt={article?.alt || "immagine di copertina"}
                  className="aspect-4/3 h-full w-full rounded-[40px] object-cover mix-blend-multiply hover:opacity-80"
                  sizes="(min-width: 769px) 50vw, (min-width: 1024px) 25vw, (min-width: 1300px) 20vw, 100vw"
                  width={500}
                  height={400}
                  placeholder="blur"
                  blurDataURL={article.thumbnail}
                  priority={index < 3}
                />
              )}
            </Link>
          </figure>
        </article>
      ))}
    </AliceCarousel>
  );
};

export default CarouselThumbLoop;
